import React from 'react'

function Aim() {
    return (
        <div className='aim row'>
            {/* <p className='paragraph-two que'>Our Aim</p> */}
            <p className='header-two ans'>Learn to hold your body the Right way.</p>
        </div>
    )
}

export default Aim
